import { Component } from '@angular/core';

import {NavController, NavParams, ViewController} from 'ionic-angular';

import { AboutPage } from '../../../about/about';
import { TestPage } from '../../../test/test';
import { MapPage } from '../../../map/map';
import { SchedulePage } from '../../../schedule/schedule';
import { SpeakerListPage } from '../../../speaker-list/speaker-list';
import {UserData} from "../../../../providers/user-data";
import {CivilityPage} from "../../civility/civility";
import {AddressPage} from "../../address/address";
import {IdentityPage} from "../../identity/identity";
import {DocumentsPage} from "../../documents/documents";
import {CvExperiencesPage} from "../experiences/experiences";
import {CvDiplomasPage} from "../diplomas/diplomas";
import {CvCertificatesPage} from "../certificates/certificates";
import {CvLanguagesPage} from "../languages/languages";


@Component({
  templateUrl: 'tabs.html'
})
export class CvTabsPage {
  // set the root pages for each tab
  tab1Root: any = CvExperiencesPage;
  tab2Root: any = CvDiplomasPage;
  tab3Root: any = CvCertificatesPage;
  tab4Root: any = CvLanguagesPage;

  mySelectedIndex: number;

  constructor(
      navParams: NavParams,
      public navCtrl: NavController,
      public user: UserData,
      public viewCtrl : ViewController
  ) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }
  ionViewWillEnter() {
    //this.user.checkLoggedIn(this.navCtrl,'SchedulePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/cv/tabs/tabs.ts